import React, { useEffect, Suspense, lazy } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDocTitle } from "./components/CustomHook";
import ScrollToTop from "./components/ScrollToTop";

// Lazy load pages for code splitting
const Home = lazy(() => import("./pages/Home"));
const Contact = lazy(() => import("./pages/Contact"));
const DemoProduct = lazy(() => import("./pages/DemoProduct"));

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <div className="text-center">
      <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-900"></div>
      <p className="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
);

function App() {
  useEffect(() => {
    // Lazy load AOS only when needed
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: "ease-out-cubic",
      });
    };

    // Use requestIdleCallback if available for better performance
    if (typeof window !== "undefined" && window.requestIdleCallback) {
      window.requestIdleCallback(
        () => {
          aos_init();
        },
        { timeout: 2000 }
      );
    } else if (typeof window !== "undefined") {
      // Fallback: initialize after page load
      if (document.readyState === "complete") {
        setTimeout(aos_init, 100);
      } else {
        window.addEventListener("load", () => {
          setTimeout(aos_init, 100);
        });
      }
    }
  }, []);

  useDocTitle(
    "UDJEMU Global Resources Ltd | Leading Indigenous Engineering & Oilfield Service Company in Nigeria"
  );

  return (
    <>
      <Router>
        <ScrollToTop>
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/get-demo" element={<DemoProduct />} />
            </Routes>
          </Suspense>
        </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
